(function () {
  'use strict';

  /*
    TIMING — all values in milliseconds, relative to scroll trigger.
    BADGE_DELAYS[i]: i=0 Relieves Constipation, i=1 Reduces Bloating,
                     i=2 Smooth Digestion, i=3 100% Natural.
    CURVE_FACTOR: arc bow as fraction of chord length (0.45 = 45%).
    MOBILE_BP: must match the CSS max-width mobile breakpoint.
  */
  var T = {
    BOTTLE_DELAY:      0,
    BOTTLE_DURATION:   400,
    LINE_DELAY:        300,
    LINE_DURATION:     2200,
    BADGE_DELAYS:      [300, 900, 1600, 2300],
    BADGE_DURATION:    420,
    BTN_EXTRA_PAUSE:   100,
    TRIGGER_THRESHOLD: 0.30
  };
  var CURVE_FACTOR = 0.45;
  var MOBILE_BP    = 640;

  /* Icon positions in SVG path order: bot-left → top-left → top-right → bot-right */
  var POS_ORDER = ['bottom_left', 'top_left', 'top_right', 'bottom_right'];

  document.querySelectorAll('.tov-benefit-section').forEach(function (sectionEl) {
    var sid = sectionEl.dataset.sectionId || '';

    /* DOM refs — scoped to this section instance */
    var layout     = document.getElementById('benefit-layout-'   + sid);
    var svgEl      = document.getElementById('benefit-svg-'      + sid);
    var pathEl     = document.getElementById('benefit-path-'     + sid);
    var bottleImg  = document.getElementById('citrus-img-'       + sid);
    var shopBtn    = document.getElementById('benefit-shop-btn-' + sid);
    var header     = document.getElementById('about-header-'     + sid);
    var citrusWrap = document.getElementById('citrus-wrap-'      + sid);

    /* Cards sorted by data-badge-index for staggered animation order */
    var cards = Array.from(sectionEl.querySelectorAll('.feature-card[data-badge-index]'));
    cards.sort(function (a, b) {
      return parseInt(a.dataset.badgeIndex, 10) - parseInt(b.dataset.badgeIndex, 10);
    });

    /*
      Build icons array in SVG path order by looking up each data-position slot.
      If any position is missing (merchant removed a block, or count != 4),
      the SVG connector is hidden and only cards animate.
    */
    var icons = POS_ORDER.map(function (pos) {
      var card = sectionEl.querySelector('[data-position="' + pos + '"]');
      return card ? card.querySelector('.feature-icon') : null;
    });
    var svgEnabled = icons.every(Boolean) && icons.length === 4;
    if (!svgEnabled && svgEl) svgEl.style.display = 'none';

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var played = false;

    /* Centre of el in SVG local space (SVG top-left == layout top-left) */
    function centreOf(el, lr) {
      var er = el.getBoundingClientRect();
      return [er.left + er.width * 0.5 - lr.left, er.top + er.height * 0.5 - lr.top];
    }

    /*
      Arc control points — quadratic-to-cubic lift.
      Peak = chord midpoint + outward normal × (chord length × CURVE_FACTOR).
      "Outward" = perpendicular to chord pointing away from the bottle centre.
      CP1/CP2 = standard 2/3 lift from each endpoint toward the peak.
    */
    function arcCP(pA, pB, imgCtr) {
      var dx  = pB[0] - pA[0], dy = pB[1] - pA[1];
      var len = Math.sqrt(dx * dx + dy * dy) || 1;
      var nCCW = [-dy / len, dx / len];
      var mx = (pA[0] + pB[0]) * 0.5, my = (pA[1] + pB[1]) * 0.5;
      var dot = (mx + nCCW[0] - imgCtr[0]) * nCCW[0] + (my + nCCW[1] - imgCtr[1]) * nCCW[1];
      var n = dot > 0 ? nCCW : [dy / len, -dx / len];
      var peak = [mx + n[0] * len * CURVE_FACTOR, my + n[1] * len * CURVE_FACTOR];
      return {
        cp1: [pA[0] + (2/3) * (peak[0] - pA[0]), pA[1] + (2/3) * (peak[1] - pA[1])],
        cp2: [pB[0] + (2/3) * (peak[0] - pB[0]), pB[1] + (2/3) * (peak[1] - pB[1])]
      };
    }

    function buildPath(pts, imgCtr) {
      var s = [arcCP(pts[0], pts[1], imgCtr), arcCP(pts[1], pts[2], imgCtr), arcCP(pts[2], pts[3], imgCtr)];
      var r = function (v) { return Math.round(v * 100) / 100; };
      return (
        'M '  + r(pts[0][0]) + ',' + r(pts[0][1]) +
        ' C ' + r(s[0].cp1[0])+','+r(s[0].cp1[1])+' '+r(s[0].cp2[0])+','+r(s[0].cp2[1])+' '+r(pts[1][0])+','+r(pts[1][1]) +
        ' C ' + r(s[1].cp1[0])+','+r(s[1].cp1[1])+' '+r(s[1].cp2[0])+','+r(s[1].cp2[1])+' '+r(pts[2][0])+','+r(pts[2][1]) +
        ' C ' + r(s[2].cp1[0])+','+r(s[2].cp1[1])+' '+r(s[2].cp2[0])+','+r(s[2].cp2[1])+' '+r(pts[3][0])+','+r(pts[3][1])
      );
    }

    /*
      refreshPath(onDone)
      All getBoundingClientRect reads are wrapped in requestAnimationFrame
      to batch DOM reads and avoid layout thrashing.
      Calls onDone(pathLength) — length is 0 on mobile (SVG hidden) or if SVG disabled.
    */
    function refreshPath(onDone) {
      if (!svgEnabled || !layout || !svgEl || !pathEl || !citrusWrap) {
        if (onDone) onDone(0);
        return;
      }
      requestAnimationFrame(function () {
        if (window.innerWidth <= MOBILE_BP) {
          if (onDone) onDone(0);
          return;
        }

        var lr = layout.getBoundingClientRect();
        svgEl.setAttribute('viewBox', '0 0 ' + lr.width + ' ' + lr.height);
        svgEl.setAttribute('width',  lr.width);
        svgEl.setAttribute('height', lr.height);

        var ir = citrusWrap.getBoundingClientRect();
        var imgCtr = [ir.left + ir.width * 0.5 - lr.left, ir.top + ir.height * 0.5 - lr.top];

        var pts = icons.map(function (el) { return centreOf(el, lr); });
        pathEl.setAttribute('d', buildPath(pts, imgCtr));

        if (onDone) onDone(pathEl.getTotalLength());
      });
    }

    function playAnimations() {
      if (played) return;
      played = true;

      if (prefersReduced) {
        if (bottleImg) bottleImg.style.cssText += 'opacity:1;transform:none;';
        if (pathEl)    pathEl.style.cssText    += 'opacity:1;stroke-dashoffset:0;';
        cards.forEach(function (c) { c.style.cssText += 'opacity:1;transform:none;'; });
        if (shopBtn)   shopBtn.style.cssText   += 'opacity:1;transform:none;';
        return;
      }

      if (bottleImg) {
        bottleImg.animate(
          [{ opacity: 0, transform: 'scale(0.9)' }, { opacity: 1, transform: 'scale(1)' }],
          { delay: T.BOTTLE_DELAY, duration: T.BOTTLE_DURATION, easing: 'ease-out', fill: 'forwards' }
        );
      }

      refreshPath(function (len) {
        if (len > 0 && pathEl) {
          pathEl.style.opacity = '1';
          pathEl.style.strokeDasharray  = len;
          pathEl.style.strokeDashoffset = len;
          pathEl.animate(
            [{ strokeDashoffset: len }, { strokeDashoffset: 0 }],
            { delay: T.LINE_DELAY, duration: T.LINE_DURATION, easing: 'ease-in-out', fill: 'forwards' }
          );
        }
      });

      cards.forEach(function (card, i) {
        card.animate(
          [
            { opacity: 0, transform: 'scale(0.6)'  },
            { opacity: 1, transform: 'scale(1.12)' },
            { opacity: 1, transform: 'scale(0.95)' },
            { opacity: 1, transform: 'scale(1)'    }
          ],
          { delay: T.BADGE_DELAYS[i] || 0, duration: T.BADGE_DURATION, easing: 'ease-out', fill: 'forwards' }
        );
      });

      if (shopBtn) {
        var lastBadgeEnd = T.BADGE_DELAYS[T.BADGE_DELAYS.length - 1] + T.BADGE_DURATION;
        shopBtn.animate(
          [{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { delay: lastBadgeEnd + T.BTN_EXTRA_PAUSE, duration: 400, easing: 'ease-out', fill: 'forwards' }
        );
      }
    }

    /* Debounced resize — updates path and keeps dash state correct */
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        refreshPath(function (newLen) {
          if (newLen === 0 || !pathEl) return;
          pathEl.style.strokeDasharray  = newLen;
          pathEl.style.strokeDashoffset = played ? '0' : newLen;
        });
      }, 150);
    });

    /* Scroll triggers */
    if (header) {
      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          header.classList.add('visible');
          obs.unobserve(header);
        });
      }, { threshold: 0.1 }).observe(header);
    }

    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        playAnimations();
        obs.unobserve(sectionEl);
      });
    }, { threshold: T.TRIGGER_THRESHOLD }).observe(sectionEl);

    /* Initial path setup after images are loaded and sized */
    function init() {
      refreshPath(function (len) {
        if (len > 0 && pathEl) {
          pathEl.style.strokeDasharray  = len;
          pathEl.style.strokeDashoffset = len;
        }
      });
    }

    if (document.readyState === 'complete') { init(); }
    else { window.addEventListener('load', init); }

  });

}());
